<template>
  <div class="sidebar">
    <ul>
      <li v-for="section in sections" :key="section.id">
        <div @click="toggleSection(section.id)" class="section-header">
          <span v-if="section.children && section.children.length" class="toggle-icon">
            {{ expandedSections.includes(section.id) ? '-' : '+' }}
          </span>
          <a class="title-parent">{{ section.sectionTitle }}</a>
        </div>
        <ul v-if="expandedSections.includes(section.id) && section.children && section.children.length">
          <li v-for="child in section.children" :key="child.id">
            <a class="title-child" @click="logChildId(child.id)">{{ child.sectionTitle }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DocumentSidebar",
  props: {
    sections: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      expandedSections: []
    };
  },
  methods: {
    toggleSection(parentId) {
      const index = this.expandedSections.indexOf(parentId);
      if (index > -1) {
        this.expandedSections.splice(index, 1);
      } else {
        this.expandedSections.push(parentId);
      }
      this.$store.commit("setActiveSection", parentId)
      this.$store.commit("setCurrentSectionId", parentId)
    },
    logChildId(childId) {
      this.$store.commit("setActiveSection", childId)
      this.$store.commit("setCurrentSectionId", childId)
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  padding: 20px;
  background-color: white;
  height: 100vh;
  border-right: 1px solid #ddd;
}

.sidebar ul {
  list-style-type: none;
  padding: 0;
}

.sidebar li {
  position: relative;
}

.sidebar li::before {
  position: absolute;
  left: 0;
  top: 0;
}

.section-header {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.toggle-icon {
  margin-right: 5px;
  font-weight: bold;
  width: 10px;
}

.sidebar a {
  text-decoration: none;
  color: #000;
  font-weight: medium;
  display: block;
  padding: 6px;
  transition: color 0.3s ease;
  width: 100%;
}

.title {

  &-parent {
    font-weight: 400;
    width: 100%;
    border-bottom: 1px rgb(240, 240, 240) solid;
  }

  &-child {
    font-weight: 200;
    border-bottom: 1px rgb(240, 240, 240) solid;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 120px;
  }
}

.sidebar a:hover {
  background-color: #fafafa;
}

.sidebar ul ul {
  border-left: 1px dashed #ddd;
  padding-left: 10px;
}
</style>
